import React from 'react';
import { BiEdit, BiTrash } from 'react-icons/bi';

import Bouton from '../../UI/Bouton/Bouton';
import FunctionBuilder from '../FunctionBuilder/FunctionBuilder';

import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import S from './FunctionProfil.module.scss';

const FunctionProfil = ({ functionData, editerFunction, onDelete }) => {
  if (!functionData || !functionData.id_function) {
    return (
      <div className={S.emptyState}>
        <h3>Aucune fonction sélectionnée</h3>
        <p>Sélectionnez une fonction dans le tableau pour voir les détails.</p>
      </div>
    );
  }

  return (
    <div className={S.profilContainer}>
      <div className={S.header}>
        <div className={S.headerInfo}>
          <div className={S.functionTitle}>
            <h2 className={S.functionName}>{functionData.name}</h2>
            <div className={S.functionMeta}>
              <span className={S.functionId}>
                ID: {functionData.id_function}
              </span>
            </div>
          </div>
        </div>
        <div className={S.headerActions}>
          <Bouton
            type={type_btn.secondary}
            rond={true}
            taille="small"
            cliquer={() => editerFunction(functionData)}
            className={S.actionBtn}
          >
            <BiEdit size={16} />
          </Bouton>
          <Bouton
            type={type_btn.danger}
            rond={true}
            taille="small"
            cliquer={onDelete}
            className={S.actionBtn}
          >
            <BiTrash size={16} />
          </Bouton>
        </div>
      </div>
      <div className={S.tabContent}>
        <FunctionBuilder
          initialFunction={functionData}
          isEditMode={true}
          readOnly={true}
          annuler={() => {}}
          sauvegarderFunction={() => {}}
        />
      </div>
    </div>
  );
};

export default FunctionProfil;
